// Préférence d'apparence de l'application : « light », « dark » ou « system ».
//
// Elle est volontairement locale au navigateur : le thème n'appartient pas au compte,
// et l'API n'expose aucun réglage de ce type. Le mode « system » suit en direct les
// changements de thème du système d'exploitation ou du navigateur.
import { reactive } from 'vue'

const STORAGE_KEY = 'gesrecette:theme'
const MODES = ['light', 'dark', 'system']

const media = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null

function readStored() {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return MODES.includes(value) ? value : 'system'
  } catch (e) {
    return 'system' // stockage indisponible : on se rabat sur le thème du système
  }
}

export const theme = reactive({
  mode: readStored(),
  /** Ce que demande le système ; sans objet tant que « system » n'est pas le mode choisi. */
  systemDark: media ? media.matches : false,

  /** Vrai si l'interface doit être rendue sombre. */
  get isDark() {
    return this.mode === 'dark' || (this.mode === 'system' && this.systemDark)
  },

  /** Bascule clair ⇄ sombre en partant de l'état affiché, quel que soit le mode choisi. */
  toggle() {
    this.set(this.isDark ? 'light' : 'dark')
  },

  /** @param {'light'|'dark'|'system'} mode */
  set(mode) {
    if (!MODES.includes(mode)) return
    this.mode = mode
    try {
      localStorage.setItem(STORAGE_KEY, mode)
    } catch (e) {
      /* la préférence ne sera pas mémorisée, le thème s'applique quand même */
    }
    this.apply()
  },

  /** Reporte l'état sur <html> : c'est ce que Tailwind et le navigateur lisent. */
  apply() {
    const root = document.documentElement
    root.classList.toggle('dark', this.isDark)
    // Rend les champs de formulaire, barres de défilement et listes natives cohérents.
    root.style.colorScheme = this.isDark ? 'dark' : 'light'
  },

  /** À appeler une fois au démarrage, puis le store reste à jour tout seul. */
  init() {
    this.apply()
    if (!media) return
    const onChange = (event) => {
      this.systemDark = event.matches
      // Seul le mode « system » doit suivre l'OS : un choix explicite prime.
      if (this.mode === 'system') this.apply()
    }
    // Safari < 14 n'expose que addListener.
    if (media.addEventListener) media.addEventListener('change', onChange)
    else media.addListener(onChange)
  }
})